import { useAtom } from 'jotai';
import { io } from 'socket.io-client';
import React, { useEffect } from 'react';
import { socketIO } from '../jotaiStore/socket';
import { hostname } from '../utility/apiUtils';

function SocketEventScreen() {
  const [, setSocketIO] = useAtom(socketIO);

  useEffect(() => {
    const socket = io(hostname());

    socket?.on('connect', () => {
      setSocketIO(socket);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return <></>;
}

export default SocketEventScreen;
